import React from "react";
import {
  Platform,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

export default StyleSheet.create({
  container: {
    flex: 1,
    marginTop: Platform.OS == "android" ? 20 : 5,
    backgroundColor: "#111",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingBottom: Platform.OS == "ios" ? 10 : 5,
  },
  soundIconBox: {
    backgroundColor: "#111",
    flex: 0.8,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  contolBox: {
    backgroundColor: "#CC0000",
    flex: 1.6,
  },
  soundInfo: {
    padding: 15,
    backgroundColor: "orange",
    minWidth: 150,
    maxWidth: 150,
    alignItems: "center",
  },
  soundInfoText: {
    textAlign: "center",
    flexWrap: "wrap",
    color: "#550088",
    minWidth: 150,
    maxWidth: 150,
    alignItems: "center",
    fontSize: 16,
    adjustsFontSizeToFit: true,
  },
  title: {
    fontSize: 22,
    color: "white",
  },
  largeText: {
    fontSize: 22,
  },
  smallText: {
    fontSize: 16,
  },
  centered: {
    alignItems: "center",
  },
  controls: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  control: {
    marginTop: Platform.OS == "ios" ? 5 : Platform.OS == "android" ? 0 : 5,
    marginBottom: 2,
    marginLeft: 15,
    marginRight: 15,
  },
  timePicker: {
    backgroundColor: "#333",
    padding: 15,
    borderRadius: 8,
    marginBottom: 8,
  },
  timePickerSmall: {
    padding: 10,
    marginBottom: 5,
  },
  timeColumn: {
    alignItems: "flex-start",
    marginBottom: 10,
  },
  timeColumnSmall: {
    marginBottom: 5,
  },
  timeLabel: {
    color: "#fff",
    fontSize: 20,
    marginBottom: 5,
    textAlign: "center",
    fontWeight: "600",
  },
  timeLabelSmall: {
    fontSize: 16,
    marginBottom: 3,
  },
  timeArrows: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  timeArrow: {
    backgroundColor: "#555",
    padding: 8,
    borderRadius: 4,
    minWidth: 40,
    alignItems: "center",
  },
  timeText: {
    color: "#fff",
    fontSize: 48,
    fontWeight: "bold",
  },
  timeTextSmall: {
    fontSize: 36,
  },
  draggableNumber: {
    backgroundColor: "transparent",
    padding: 8,
    borderRadius: 8,
    minWidth: 80,
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 5,
  },
  draggableNumberSmall: {
    padding: 5,
    marginVertical: 2,
  },
  webTimeInput: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 10,
  },
  webTimeButton: {
    padding: 8,
    borderRadius: 8,
    minWidth: 80,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  webTimeArrows: {
    flexDirection: "column",
    marginLeft: -12,
  },
  webArrow: {
    padding: 4,
    borderRadius: 4,
    minWidth: 30,
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 1,
    backgroundColor: "transparent",
  },
  webArrowText: {
    fontSize: 16,
    fontWeight: "bold",
  },
  timeColon: {
    color: "#fff",
    fontSize: 48,
    fontWeight: "bold",
    marginHorizontal: 5,
    marginTop: 12,
  },
  timeColonSmall: {
    fontSize: 36,
    marginTop: 8,
  },
  // textInput: {
  //   height: 40,
  //   margin: 12,
  //   borderWidth: 1,
  //   padding: 10,
  // },
});
